const axios = require("axios");
const util = require("@/util");
import { Message } from 'element-ui';

export default {
    /**
   * 取得当前登录用户
   */
    getLoginUser() {
        return util.getFromLocalStorage("loginUser");
    },
    /**
       * 取得当前登录用户的token
       */
    getLoginUserToken() {
        let loginUser = this.getLoginUser();
        if (loginUser) {
            return loginUser.token;
        } else {
            return "";
        }
    },

    /**
    * 取得当前登录用户的角色
    */
    getLoginUserRole() {
        let loginUser = this.getLoginUser();
        if (loginUser) {
            return loginUser.role;
        } else {
            return "";
        }
    },

    /**
     * 查询渠道集合
     * 
     * @returns 
     */
    async loadAvailableChannels() {
        let resData = (
            await axios.get(
                `${util.getBackendApiBase()}/v1/getChannelList`,
                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        let availableChannels = [];

        for (let e of resData.data.channels) {
            availableChannels.push({
                id: e.id,
                name: e.name,
            });
        }

        return availableChannels;
    },
    /**
    * 查询附件集合
    */
    async loadAttachments(isShowPayItem) {
        let entries = {}
        let resData = (
            await axios.get(
                `${util.getBackendApiBase()}/v1/getAppendixList`,

                {
                    headers: {
                        token: this.getLoginUserToken(),
                    },
                }
            )
        ).data;
        if (resData.code > 0) {
            Message({
                message: resData.message,
                type: "error",
            });
            return;
        }

        for (let category of resData.data.categories) {
            for (let e of category.entries) {
                entries[e.id] = e.name
            }
        }

        return entries
    },
}